
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'IconClose',
  props: {
    width: {
      type: [String, Number] as PropType<string | number>,
      default: 24
    },
    height: {
      type: [String, Number] as PropType<string | number>,
      default: 24
    },
    color: {
      type: String,
      default: 'currentColor'
    }
  }
})
